import { TextField, Button } from "@mui/material";
import { useState } from "react";
import { convertNumber } from '../../../../../../../Helpers/function.js';
import { useTranslation } from "react-i18next";

function Time(props) {
    const { t } = useTranslation();
    const date = new Date();
    const dateStart = date.getFullYear() + '-' + convertNumber(date.getMonth() + 1) + '-' + convertNumber(date.getDate());
    const dateEnd = date.getFullYear() + '-' + convertNumber(date.getMonth() + 1) + '-' + convertNumber(date.getDate());
    const [date_start, setDateStart] = useState(dateStart);
    const [date_end, setDateEnd] = useState(dateEnd);

    const getRangDate = () => {
        props.responseProps(date_start, date_end);
    }
    return (
        <div className='list-saler date-search'>
            <p style={{textAlign: 'left', paddingLeft: '20px'}} className="m-t-0">{t("order.label.from")}:</p>
            <TextField
                id="date"
                // label="Từ"
                type="date"
                // value={date_start}
                onChange={(e) => setDateStart(e.target.value)}
            />
            <p style={{textAlign: 'left', paddingLeft: '20px'}}>{t("order.label.to")}:</p>
            <TextField
                id="date"
                // label="Đến"
                type="date"
                // value={date_end}
                onChange={(e) => setDateEnd(e.target.value)}
            />
            <Button onClick={getRangDate} sx={{textAlign: "left", marginTop: "20px"}} variant="contained">
                {t("common.confirm")}
            </Button>
        </div>
    )
}

export default Time;